/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { AlarmRulesResponse, SignalAlarmRuleInput } from "../models/index";
import {
  AlarmRulesResponseFromJSON,
  AlarmRulesResponseToJSON,
  SignalAlarmRuleInputFromJSON,
  SignalAlarmRuleInputToJSON,
} from "../models/index";

export interface DeleteSignalAlarmRuleRequest {
  signalAlarmRuleId: string;
}

export interface EditSignalAlarmRuleRequest {
  signalAlarmRuleInput: SignalAlarmRuleInput;
}

export interface InsertSignalAlarmRuleRequest {
  signalAlarmRuleInput: SignalAlarmRuleInput;
}

/**
 *
 */
export class SignalAlarmRulesApi extends runtime.BaseAPI {
  /**
   */
  async deleteSignalAlarmRuleRaw(
    requestParameters: DeleteSignalAlarmRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["signalAlarmRuleId"] == null) {
      throw new runtime.RequiredError(
        "signalAlarmRuleId",
        'Required parameter "signalAlarmRuleId" was null or undefined when calling deleteSignalAlarmRule().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["signalAlarmRuleId"] != null) {
      queryParameters["signalAlarmRuleId"] =
        requestParameters["signalAlarmRuleId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/signal-alarm-rules/delete-rule`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteSignalAlarmRule(
    requestParameters: DeleteSignalAlarmRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteSignalAlarmRuleRaw(requestParameters, initOverrides);
  }

  /**
   */
  async editSignalAlarmRuleRaw(
    requestParameters: EditSignalAlarmRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["signalAlarmRuleInput"] == null) {
      throw new runtime.RequiredError(
        "signalAlarmRuleInput",
        'Required parameter "signalAlarmRuleInput" was null or undefined when calling editSignalAlarmRule().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/signal-alarm-rules/edit-rule`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SignalAlarmRuleInputToJSON(
          requestParameters["signalAlarmRuleInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editSignalAlarmRule(
    requestParameters: EditSignalAlarmRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editSignalAlarmRuleRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getSignalAlarmRulesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AlarmRulesResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/signal-alarm-rules/get-rules`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AlarmRulesResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getSignalAlarmRules(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AlarmRulesResponse> {
    const response = await this.getSignalAlarmRulesRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async insertSignalAlarmRuleRaw(
    requestParameters: InsertSignalAlarmRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["signalAlarmRuleInput"] == null) {
      throw new runtime.RequiredError(
        "signalAlarmRuleInput",
        'Required parameter "signalAlarmRuleInput" was null or undefined when calling insertSignalAlarmRule().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/signal-alarm-rules/insert-rule`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SignalAlarmRuleInputToJSON(
          requestParameters["signalAlarmRuleInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async insertSignalAlarmRule(
    requestParameters: InsertSignalAlarmRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.insertSignalAlarmRuleRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
